import { Check } from "lucide-react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import type { JourneyStep } from "./derive";

/** "Your journey with us" — a plain-language timeline derived from the client's
 * real progress signals (requested docs, financials, proposals). */
export function JourneyCard({ steps }: { steps: JourneyStep[] }) {
  return (
    <Card className="gap-4 p-7">
      <div>
        <h3 className="font-heading text-xl font-bold text-foreground">Your journey with us</h3>
        <p className="text-muted-foreground mt-0.5 text-sm">Where things are, in plain words.</p>
      </div>
      <ol className="flex flex-col">
        {steps.map((step, i) => {
          const last = i === steps.length - 1;
          return (
            <li key={step.title} className="flex gap-3.5">
              <div className="flex flex-col items-center">
                <span
                  className={cn(
                    "grid size-6 shrink-0 place-items-center rounded-full",
                    step.state === "done" && "bg-success text-white",
                    step.state === "current" && "border-primary bg-primary-soft border-2",
                    step.state === "upcoming" && "border-2",
                  )}
                >
                  {step.state === "done" ? (
                    <Check className="size-3" />
                  ) : step.state === "current" ? (
                    <span className="bg-primary size-2 rounded-full" />
                  ) : null}
                </span>
                {!last && (
                  <span
                    className={cn("my-1 w-0.5 flex-1", step.state === "done" ? "bg-success" : "bg-border")}
                  />
                )}
              </div>
              <div className={cn("pb-5", last && "pb-0")}>
                <div
                  className={cn(
                    "font-semibold",
                    step.state === "current" ? "text-warning" : "text-foreground",
                  )}
                >
                  {step.title}
                </div>
                <div className="text-muted-foreground text-sm">{step.blurb}</div>
              </div>
            </li>
          );
        })}
      </ol>
    </Card>
  );
}
